<template>
  <div style="background: #f9f9f9; padding-bottom: 80px" class="adaptiveMobileNewClass">
    <div class="new_top_nap">
      <span>当前位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }" @click="getNewsItem">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/dynamicState' }" @click="getNewsItem" v-if="titleName=='协会动态' || titleName_1 == '协会动态'">水泵协会</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }" @click="getNewsItem" v-else>新闻资讯</el-breadcrumb-item>
        <el-breadcrumb-item v-if="titleName">{{ titleName }}</el-breadcrumb-item>
        <el-breadcrumb-item v-else>{{ titleName_1 }}</el-breadcrumb-item>
        <!-- <el-breadcrumb-item v-if="titleName_1">{{ titleName_1 }}</el-breadcrumb-item> -->
      </el-breadcrumb>
    </div>
    <div class="new_con" v-loading="loading">
      <h2>
        {{ newDetail.title }}
      </h2>
      <div class="flex new_con_box">
        <div class="new_con_left flex">
          <p v-if="newDetail.source != null && newDetail.source!=''">来源：{{ newDetail.source }}</p>
          <p>发布时间：{{ newDetail.createDate }}</p>
          <p>
            <i class="iconfont">&#xe611;</i>
            <span> {{ newDetail.pageViews }} </span>
          </p>
        </div>
        <div class="new_con_right flex">
          <p class="flex">
            <i v-if=newDetail.isCollection class="el-icon-star-on"
               style="margin-right: 8px;color: #E6A23C;cursor: pointer;font-size: 24px;"
               @click="deleteCollectionNews"></i>
            <i v-if=!newDetail.isCollection class="el-icon-star-off"
               style="margin-right: 8px;cursor: pointer;font-size: 20px;" @click="collectionNews"></i>
            <span> {{ newDetail.collectionsNum }}</span>
          </p>
          <i class="new_icon"></i>
          <p class="flex">
            <i v-if=newDetail.isLike class="iconfont"
               style="margin-right: 8px;color: #E6A23C;cursor: pointer;" @click="deleteNewsFabulous">&#xe665;</i>
            <i v-if=!newDetail.isLike class="iconfont" style="margin-right: 8px;cursor: pointer;"
               @click="saveNewsFabulous">&#xe665;</i>
            <span> {{ newDetail.likesNum }} </span>
          </p>
          <i class="new_icon"></i>
          <p class="flex">
            <share :config="config" style="z-index: 99;"></share>
          </p>
        </div>
      </div>
      <div class="new_con_mess editorStyleDetailContent ql-editor vHtmlMess" v-html="newDetail.content"></div>
      <div class="flex new_bottom">
        <div class="new_bottom_left" @click="beforeDetail">
          <p class="flex"><i></i> 上一篇</p>
          <p v-if="before != null">{{ before.title }}</p>
        </div>
        <div class="new_bottom_right" @click="afterDetail">
          <p class="flex">下一篇<i></i></p>
          <p v-if="after != null">{{ after.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import QRCode from 'qrcodejs2';
import {
  getNewcurrent,
  getNewDetail,
  saveNewsCollection,
  deleteNewsCollection,
  saveNewsFabulous,
  deleteNewsFabulous,
  getProgramChildList
} from "../../../utils/interface";

export default {
  //   新闻
  name: "news",
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [{                 // set meta
        name: "keywords",
        content: this.metaKeywords,
      },
        {                 // set meta
          name: "description",
          content: this.metaDescription,
        }
      ],
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      config: {
        url: window.location.href,
        disabled: ['douban', 'linkedin', 'diandian', 'qq', 'qzone', 'tencent', 'google', 'twitter', 'tencent', 'weibo']
      },
      uuid: "",
      newDetail: "",
      before: {
        uuid: "",
      },
      after: {
        uuid: "",
      },
      showERCode: false,
      titleName: "",
      titleName_1: "",
      programUuid: null,
      setIn: null, // 定时器
      userDetail: {},
      metaTitle: '',
      metaKeywords: '',
      metaDescription: '',
    };
  },
  created() {
    this.backTop();
    this.uuid = this.$route.params.uuid;
    this.programUuid = this.$route.query.programUuid;
    this.titleName = "";
    this.titleName_1 = "";
    this.getNewcurrent();
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getNewsDetail();
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    this.creatQrCode();
  },
  destroyed() {
  },
  methods: {
    backTop() {
      let timer = setInterval(function () {
        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var speed = top / 4;
        if (document.body.scrollTop != 0) {
          document.body.scrollTop -= speed;
        } else {
          document.documentElement.scrollTop -= speed;
        }
        if (top == 0) {
          clearInterval(timer);
        }
      }, 30);
    },

    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: window.location.href, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },

    forwardNews() {
      if (this.showERCode) {
        this.showERCode = false;
      } else if (!this.showERCode) {
        this.showERCode = true;
      }
    },

    getNewcurrent() {
      if (!this.$store.state.isLogin) {
        return;
      }
      getNewcurrent().then((res) => {
        this.userDetail = res;
      })
    },


    collectionNews() {
      if (!this.$store.state.isLogin) {
        this.$message.success("您需要先登陆哦！")
        this.$router.push("/login");
      }
      let param = {
        newsUuid: this.newDetail.uuid,
        userId: this.userDetail.uuid,
      }
      saveNewsCollection(param).then((response) => {
        this.getNewsDetail();
      })
    },
    deleteCollectionNews() {
      if (!this.$store.state.isLogin) {
        this.$message.success("您需要先登陆哦！")
        // return false;
        this.$router.push("/login");
      }
      let param = {
        newsUuid: this.newDetail.uuid,
        userId: this.userDetail.uuid,
      }
      deleteNewsCollection(param).then((response) => {
        this.getNewsDetail();
      })
    },

    saveNewsFabulous() {
      if (!this.$store.state.isLogin) {
        this.$message.success("您需要先登陆哦！")
        // return false;
        this.$router.push("/login");
      }
      let param = {
        newsUuid: this.newDetail.uuid,
        userId: this.userDetail.uuid,
      }
      saveNewsFabulous(param).then((response) => {
        this.getNewsDetail();
      })
    },
    deleteNewsFabulous() {
      if (!this.$store.state.isLogin) {
        this.$message.success("您需要先登陆哦！")
        this.$router.push("/login");
        // return false;
      }
      let param = {
        newsUuid: this.newDetail.uuid,
        userId: this.userDetail.uuid,
      }
      deleteNewsFabulous(param).then((response) => {
        this.getNewsDetail();
      })
    },

    getNewsDetail() {
      let param = {};
      param.uuid = this.uuid;
      param.programUuid = this.programUuid;
      if (this.$store.state.isLogin) {
        param.userId = this.userDetail.uuid;
      }
      this.loading = true
      getNewDetail(param).then((res) => {
        this.loading = false
        if (res.success) {
          this.metaTitle = res.data.current.title;
          this.metaKeywords = res.data.current.metaKeywords;
          this.metaDescription = res.data.current.metaDescription;

          this.newDetail = res.data.current;
          this.before = res.data.before;
          this.after = res.data.after;
          this.config.title = res.data.current.title;
          this.config.description = res.data.current.summary;
          this.config.image = res.data.current.pictureUrl;
          let param = {
            uuid: res.data.current.programUuid,
          }
          var reg_exp = new RegExp("video-js", "g");
          this.newDetail.content = this.newDetail.content.replace(reg_exp, "");

          getProgramChildList(param).then((response) => {
            if (response.length > 0) {
              this.titleName = response[0].parentName;
              this.titleName_1 = response[0].label;
            } else {
              this.titleName = response[0].programName;
            }
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    beforeDetail() {
      if (this.before != null) {
        this.$router.push({
          name: "introductionNews",
          params: {
            uuid: this.before.uuid,
          }
        })
        this.uuid = this.before.uuid;
        this.getNewsDetail();
      }
    },
    afterDetail() {
      if (this.after != null) {
        this.$router.push({
          name: "introductionNews",
          params: {
            uuid: this.after.uuid,
          }
        })
        this.uuid = this.after.uuid;
        this.getNewsDetail();
      }
    },
    getNewsItem() {
      this.$router.push({
        name: "news",
        params: {
          programUuid: this.programUuid,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/dist/css/share.min.css";

.blue {
  color: #009999;
}

.red {
  color: #d60000;
}

.soluBanner {
  position: relative;
  width: 100%;

  img {
    width: 100%;
    display: block;
  }

  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;

    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }

    .soluBanText {
      // margin: 8px 0 60px;
      p:nth-child(1) {
        font-size: 17px;
      }

      p:nth-child(2) {
        font-size: 9px;
      }
    }
  }
}

.new_top_nap {
  font-size: 14px;
  color: #808080;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;

  span {
    color: #808080;
  }
}

.new_con {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 80px;
  background: #fff;

  h2 {
    color: #082a48;
    //border-bottom: 1px solid #efefef;
    text-align: center;
    font-size: 26px;
    padding: 15px 0;
  }

  .new_con_box {
    font-size: 13px;
    border-bottom: 1px solid #efefef;
    color: #bbb;
    justify-content: space-between;
    margin: 10px 0;
    padding: 0 40px;

    .new_con_left {
      margin-top: 7px;
      margin-bottom: 10px;

      p {
        margin-right: 25px;
      }

      p:nth-last-child(1) {
        align-items: center;

        i {
          margin-right: 5px;
        }
      }
    }

    .new_con_right {
      align-items: center;
      margin-bottom: 10px;

      p {
        align-items: center;

        i {
          margin-right: 5px;
        }
      }

      .new_icon {
        width: 1px;
        height: 10px;
        background: #efefef;
        margin: 0 15px;
      }
    }
  }

  .new_con_mess {
    margin: 35px 0 20px;
    border-bottom: 1px solid #efefef;
    padding: 0 40px;
    padding-bottom: 20px;
    white-space: pre-wrap;

    p {
      margin-bottom: 20px;
      // text-indent: 2em;
      font-size: 15px;
      line-height: 30px;
      // color: #777;
    }

    /deep/ img {
      max-width: 100% !important;
    }

    // .new_img {
    //     text-align: center;

    //     img {
    //         width: 50%;
    //     }
    // }

    /deep/ span {
      font-size: 15px;
      line-height: 30px;
      // color: #777 ;
    }
  }

  .new_bottom {
    position: relative;
    align-content: center;
    font-size: 14px;
    justify-content: space-between;
    padding: 0 40px;
    padding-bottom: 20px;
    height: 40px;
    cursor: pointer;

    .new_bottom_left {
      color: #082a48;

      p:nth-child(1) {
        align-items: center;

        i {
          width: 5px;
          height: 15px;
          border-radius: 5px;
          background: #082a48;
          margin-right: 6px;
          display: inline-block;
        }
      }

      p:nth-child(2) {
        padding-left: 11px;
        margin-top: 4px;
        width: 88%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .new_bottom_right {
      color: #082a48;
      text-align: right;

      p:nth-child(1) {
        align-items: center;
        i {
          width: 5px;
          height: 15px;
          border-radius: 5px;
          background: #082a48;
          margin-left: 6px;
          display: inline-block;
        }
      }

      p:nth-child(2) {
        padding-left: 11px;
        margin-top: 4px;
        text-align: right;
        position: absolute;
        right: 37px;
        width: 30%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        
      }
    }
  }
}

.editorStyleDetailContent {
  /deep/ .video-wrap {
    video {
      width: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/association/components/newDetails.vue